<script>
// Extensions
import View from "@/views/home/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Home",

  metaInfo: { title: "Home" },

  extends: View,

  mixins: [
    LoadSections([
      "rates",
      // "hero",
      // "search-wizard",
      // "theme-features",
      // "features",
      "contact-us",
      // "affiliates",
      // "social-media",
      // "keep-in-touch",
      // "pro-features",
      // "newsletter",
      "footer-info",
    ]),
  ],

  props: {
    id: {
      type: String,
      default: "home",
    },
  },
};
</script>
